/**
 * 「目标」页筛选：**一个节点属于哪些筛选标签**（2026-10-30 修正）。
 *
 * ## 用户报的 bug
 *
 * > "'强身健体'我已经归档了，上面筛选我也没有选'已归档'，为什么这一块还显示？"
 *
 * 截图里筛选是默认的「进行中 + 暂停」，计数显示 `进行中(16)`、`已归档(1)` ——
 * 一共 16 个节点，却有 16 个"进行中"**加上** 1 个"已归档"，说明那个已归档的节点
 * 被**重复计入了两次**：它状态仍是 `active`，同时又带着 `archivedAt`。
 *
 * ## 规则
 *
 * **归档是独立维度，但它是一个"标签位"而不是"附加标记"**：
 * 已归档的节点**只属于「已归档」**，不再计入它的原状态（进行中/暂停/完成/停止）。
 *
 * 理由：归档的语义就是"从默认视图里拿掉，历史保留"。如果它同时仍算"进行中"，
 * 那么默认筛选（进行中+暂停）永远会把它带回来 —— 等于归档没生效。
 * 需要看它们时点「已归档」；点「全部」也仍然能看到全部（那里不做任何过滤）。
 */
import type { NodeStatus } from '@fht/shared';

/** 筛选标签的取值：四种状态 + 独立的「已归档」。 */
export type NodeFilterKey = NodeStatus | 'archived';

/** 一个节点归属的筛选标签（**归档优先且互斥**）。 */
export function nodeFilterKeys(node: {
  status: NodeStatus;
  archivedAt: string | null;
}): NodeFilterKey[] {
  return node.archivedAt !== null ? ['archived'] : [node.status];
}
